import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const pdfViewerV3PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate pdf viewer external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'pdfViewer'>): void => {
    const offset = props.style?.general?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
